import { get, post, put, destroy } from "./base";

const OfferServ = {
    // Get all offers (Admin)
    getAll: (params) => get("/offers", { params }),

    // Get single offer by ID
    getById: (id) => get(`/offers/${id}`),

    // Upload offer image (Admin)
    uploadImage: (formData) => post("/offers/upload-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }),

    // Create offer
    create: (payload) => post("/offers", payload),

    // Update offer
    update: (id, payload) => put(`/offers/${id}`, payload),

    // Delete offer
    remove: (id) => destroy(`/offers/${id}`),

    // Get offers for specific user
    getByUser: (userId) => get(`/offers/user/${userId}`),
};

export default OfferServ;
